export enum ItemAccountType {
    Facture = 1,
    Avoir = 2
}
